import { render, staticRenderFns } from "./KnifeDetectionPage.vue?vue&type=template&id=1adc549b&scoped=true"
import script from "./KnifeDetectionPage.vue?vue&type=script&lang=js"
export * from "./KnifeDetectionPage.vue?vue&type=script&lang=js"
import style0 from "./KnifeDetectionPage.vue?vue&type=style&index=0&id=1adc549b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1adc549b",
  null
  
)

export default component.exports